import { Link, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { categories } from "@/mocks/news";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-100">
      <Header />
      <main className="flex flex-1 items-center justify-center px-4 py-20 md:px-6">
        <div className="w-full max-w-xl text-center">
          <p className="font-heading text-7xl font-extrabold text-primary-200 md:text-9xl">
            404
          </p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
            这条页面走丢了
          </h1>
          <p className="mt-3 break-all text-sm text-foreground-500">
            {location.pathname}
          </p>
          <p className="mt-2 text-sm text-foreground-600">
            你要找的内容可能已被调整或链接有误，不妨从下面的入口继续逛逛。
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-search-line"></i>
              去搜索资讯
            </Link>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
            {categories.map((c) => (
              <Link
                key={c.id}
                to={`/category/${c.id}`}
                className="rounded-full bg-background-200 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}